<!-- 库存管理--快递货物 -->
<template>
<el-dialog :title="msg('快递货物')" 
    :visible.sync="visible" 
    :fullscreen="isMinScreen" 
    width="500px"
    :close-on-click-modal="false" 
>
    <div>
        <el-row :gutter="20">
            <el-col :xs="24" >
                <el-input :placeholder="msg('请输入单号搜索')" 
                    v-model="code" style="margin-top:0px;">
                    <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                </el-input>
            </el-col>
            <el-col :xs="24" style="margin-top:13px;" >
                <el-input :placeholder="msg('请输入SKU')" 
                    v-model="sku" style="margin-top:0px;">
                </el-input>
            </el-col>
            <el-col :xs="24" style="margin-top:13px;" >
                <el-input :placeholder="msg('请输入货号')" 
                    v-model="variationSku" style="margin-top:0px;">
                </el-input>
            </el-col>
            <el-col :xs="24" style="margin-top:13px;" >
                <el-input :placeholder="msg('请输入单件成本')" 
                    v-model="cost" style="margin-top:0px;">
                </el-input>
            </el-col>
        </el-row>
        
        <h3>库存单号：<el-tag type="success">{{showCode}}</el-tag> 还剩 <el-input-number controls-position="right" v-model="count" size="mini" :min="0"></el-input-number> 件货物没有寄出</h3>

        <div style="text-align:center; margin-top:20px;">
            <el-button type="primary" size="mini" @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('认领并更新快递')}}</span></el-button>
            <el-button  size="mini" v-on:click="visible = false">{{msg('取消')}}</el-button>
        </div>
    </div> 
</el-dialog>
</template>

<script>
export default {
  name: 'ExpQuery',
  data(){
        return{
            code: null,
            count:null,
            inventoryId:null,
            showCode:null,
            visible: false,
            sku: null,
            variationSku: null,
            cost: null,
            preQty:0,
        }
    
    }, 
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods:{
        showDialog(){
            this.code = null;
            this.showCode = null;
            this.count = null;
            this.sku = null;
            this.visible = true;
            this.variationSku= null;
            this.cost= null;
            this.preQty = 0;
        },
        search(){
            if(!this.code){
                this.$message(this.msg('请输入单号'));
                return;            
            }
            this.$axios.get(this.$kit.api.inventory.getKuaidiInfo+"?code="+this.code)
                .then((result) => {
                    if(result.status){
                        let data = result.data;
                        this.count = data.qty;
                        this.preQty = data.qty;
                        this.inventoryId = data.id;
                        this.showCode = this.code;
                        this.sku = data.sku;
                        this.variationSku = data.variationSku;
                        this.cost = (data.cost/100).toFixed(2);
                    }else{
                        this.$message(result.msg || this.msg("该单号不是快递单号"));
                    }
                });
        },
        onSubmit(){

            if(this.count < this.preQty){
                this.$message(this.msg('数量不能低于原库存数量'));
                return; 
            }

            let inventory = {
                id:this.inventoryId,
                qty:this.count,
                sku:this.sku,
                variationSku:this.variationSku,
                cost:this.cost*100
            }
            this.$axios.post(this.$kit.api.inventory.updateKuaidiInfo+"?t=1",inventory)
            .then((result) => {
                if(result.status){
                    this.count = null;
                    this.showCode = null;
                    this.$message(result.msg || this.msg("更新成功"));
                    this.visible = false;
                }else{
                    this.$message(result.msg || this.msg("更新失败"));
                }
            });
        },
    }
}
</script>

<style scoped lang="scss">


</style>
